<template>
    <div id="editAttachment">
        <a-modal
                title="Edit Form"
                :visible="editAttachmentVis"
                @cancel="cancel()"
                width="60%"
        >
            <template slot="footer">
                <a-row type="flex" justify="end" >
                    <a-col >
                        <div class="file sbxs" :style="{background: uploadFlag ? '#efefef': '#1890ff'}">
                            {{ $t('publicLang.Upload')}}
                            <input  ref="importFilesRef"  v-on:change="fileChange($event)" type="file" :disabled="uploadFlag">
                        </div>
                    </a-col>
                    <div style="width:10px"></div>
                    <a-col >
                        <a-button type="primary" size="small" @click="attachmentSave">{{ $t('userlang.Save') }}</a-button>
                    </a-col>
                </a-row>
            </template>

            <a-form :form="editAttachment">
                <a-row :gutter="24">
                    <a-col :span="12">
                        <a-form-item label="FileName" v-bind="formItemLayout">
                            <a-input
                                :disabled="fileNameDisabled"
                                size="small"
                                v-decorator="['fileName', { rules: [{ required: true, message: 'Please upload your file!' }] }]"
                                placeholder="Please upload your file"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="FileType" v-bind="formItemLayout">
                            <a-input
                                :disabled="fileTypeDisabled"
                                size="small"
                                v-decorator="['fileType', { rules: [{ required: true, message: 'Please upload your file!' }] }]"
                                placeholder="Please upload your file"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row :gutter="24">
                    <a-col :span="12">
                        <a-form-item label="Remarks" v-bind="formItemLayout">
                            <a-input
                                size="small"
                                v-decorator="['remarks', { rules: [{  message: 'Please input your remark!' }] }]"
                                placeholder="Please input your remark"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                    </a-col>
                </a-row>                
            </a-form>
        </a-modal>

    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                // 表单需要的参数信息
                editAttachmentVis: false,
                fileNameDisabled: false,
                fileTypeDisabled: false,
                uploadFlag: false,
                editAttachment:  this.$form.createForm(this), // add project generic from
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 12 },
                        sm: { span: 14 }
                    }
                },
                assignedUserArr: [],
                userArr: [],
                scHeaderUid: '',
                nowTabIndex: '',
                // 上传
                typeUid: null,
                file: null,
                pageType: null,
            }
        },
        created() {
            this.init();
        },
        methods:{
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            show(attachmentUid, typeUid, pageType, nowTabIndex){
                this.editAttachmentVis = true;
                if(attachmentUid != null) {
                    this.getAttachmentInfo(attachmentUid);
                }
                this.typeUid = typeUid;
                this.pageType = pageType;
                this.nowTabIndex = nowTabIndex
                this.init();
            },
            cancel(){
                this.editAttachment.resetFields()
                this.editAttachmentVis = false
                this.fileNameDisabled = false
                this.fileTypeDisabled = false
                this.uploadFlag = false
                this.editAttachment.uid = null;
                this.$refs.importFilesRef.value = "";
            },
            init(){
                let params = {
                    nowTabIndex: this.nowTabIndex
                }
            },
            attachmentSave(){
                this.editAttachment.validateFields((err, values) => {
                    if(!err) {
                        // 说明是修改
                        if(this.editAttachment.uid != undefined && this.editAttachment.uid != null) {
                            // 调用保存方法 (存入信息)
                            let params = new Map();
                            params.set('uid',this.editAttachment.uid);
                            let remarks = this.editAttachment.getFieldValue("remarks");
                            if (remarks == undefined) {
                                remarks = null;
                            }
                            params.set('remarks',remarks);
                            let valuesMapObj = Object.create(null);
                            for(let[k,v] of params) {
                                valuesMapObj[k] = v;
                            }
                            ajax.post(api.UPDATEATTACHMENT, valuesMapObj).then(res => {
                                if(res.code == 200) {
                                    this.$message.success(res.msg);
                                } else {
                                    this.$customMessage.warning(res.msg)
                                }
                                this.$parent.tabData(this.nowTabIndex);
                            })
                        } else {
                            let params = new FormData();
                            if (this.file == null) {
                                this.$customMessage.warning(this.$t('generic.UnUploadFile'));
                                return
                            }
                            // 选择文件
                            params.append("file",this.file);
                            // 补充必须参数
                            params.append("typeUid", this.typeUid);
                            params.append("pageType", this.pageType);
                            params.append("formFileName", this.editAttachment.getFieldValue("fileName"))
                            let remarks = this.editAttachment.getFieldValue("remarks");
                            if (remarks == undefined) {
                                remarks = '';
                            }
                            params.append("remarks", remarks);
                            ajax.post(api.UPLOADATTACHMENT, params).then( res => {
                                if(res.code == 200) {
                                    if ( res.data.failedMsg.length === 0 ) {
                                        this.$message.success(res.data.successMsg + "！");
                                    } else {
                                        this.$customMessage.warning(res.data.failedMsg + "！")
                                    }
                                } else {
                                    this.$customMessage.warning(res.msg);
                                }
                                this.$parent.tabData(this.nowTabIndex);
                            })
                        }
                        // 清空数据
                        this.cancel();
                    }
                }).catch(function(error) {
                    alert(error);
                })
            },
            // 附件上传选中
            fileChange(el) {
                let file = event.target.files[0]; // 获取上传excel
                // 暂存file，用于后续Save时上传文件
                this.file = file;
                // 将相关信息传给后端，检查文件是否存在重名问题，如果重名返回新命名信息
                let params = new FormData();
                // 请求参数
                params.append("file",this.file);
                params.append("typeUid", this.typeUid);
                params.append("pageType", this.pageType);
                ajax.post(api.CHECKUPLOADFILEPATH, params).then( res => {
                    if(res.code == 200) {
                        // 拆解file的信息，填充到form表单
                        let fileType = [];
                        fileType = res.data.fileName.split('.');
                        // 设置form表单信息
                        this.editAttachment.setFieldsValue({'fileName': res.data.fileName});
                        this.editAttachment.setFieldsValue({'fileType': fileType[fileType.length - 1]});
                        // 将表单的两项设置为不可修改
                        this.fileNameDisabled = true;
                        this.fileTypeDisabled = true;
                        // 如果进行了重命名处理，提示重命名提示
                        if (res.data.fileName != this.file.name) {
                            this.$customMessage.warning(res.msg);
                        }
                    } else {
                        this.$customMessage.warning(res.msg);
                        this.resetDialogStatus()
                    }
                    this.$refs.importFilesRef.value = "";
                })
            },
            // 如果是编辑，查询当前数据的相关信息
            getAttachmentInfo(attachmentUid) {
                let params = {
                    uid: ''
                }
                params.uid = attachmentUid;
                // 传值，分辨是修改还是新建
                this.editAttachment.uid = attachmentUid;
                // 将表单的两项设置为不可修改
                this.fileNameDisabled = true;
                this.fileTypeDisabled = true;
                this.uploadFlag = true;
                ajax.get(api.GETATTACHMENTINFO, params).then(res => {
                    if(res.code == 200) {
                        // 设置form表单信息
                        this.editAttachment.setFieldsValue({'fileName': res.data.fileName});
                        this.editAttachment.setFieldsValue({'fileType': res.data.fileExt});
                        this.editAttachment.setFieldsValue({'remarks': res.data.remarks});
                    } else {
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            resetDialogStatus(){
                this.editAttachment.resetFields();
                this.fileNameDisabled = false;
                this.fileTypeDisabled = false;
                this.file = null;
            }
        }
    }
</script>